/**
 * أنواع المعرّفات والأسماء المشتركة.
 *
 * كل الكيانات تستخدم UUID نصيًا، وكل الأوقات تُخزَّن بصيغة ISO-8601 بتوقيت UTC،
 * بينما تُخزَّن التواريخ المحلية (local_date) بصيغة YYYY-MM-DD في منطقة زمنية
 * محددة بوضوح. هذا الفصل يمنع أخطاء الفروق الزمنية عند حساب الاستحقاق.
 */

export type UUID = string;

/** طابع زمني بتوقيت UTC بصيغة ISO-8601، مثال: 2026-01-31T06:00:00.000Z */
export type Instant = string;

/** تاريخ محلي بصيغة YYYY-MM-DD مرتبط بمنطقة زمنية */
export type LocalDate = string;

/** وقت محلي بصيغة HH:mm */
export type LocalTime = string;

/** رمز منطقة زمنية IANA، مثال: Asia/Riyadh */
export type TimeZone = string;

export function newId(): UUID {
  if (typeof globalThis.crypto?.randomUUID === 'function') {
    return globalThis.crypto.randomUUID();
  }
  // بديل آمن للبيئات القديمة فقط، وليس مسارًا أساسيًا.
  const bytes = new Uint8Array(16);
  globalThis.crypto.getRandomValues(bytes);
  bytes[6] = ((bytes[6] ?? 0) & 0x0f) | 0x40;
  bytes[8] = ((bytes[8] ?? 0) & 0x3f) | 0x80;
  const hex = [...bytes].map((b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export function nowInstant(): Instant {
  return new Date().toISOString();
}

/** مفتاح إسقاط (déterministic) لمنع إنشاء سجل تنفيذ مكرر لنفس الموعد. */
export function occurrenceKey(templateId: UUID, localDate: LocalDate): string {
  return `${templateId}:${localDate}`;
}
